import * as React from 'react';
import ToolIconRadioButtonSet from '../common/ToolIconRadioButtonSet';
import ToolIconButton from '../common/ToolIconButton';
import {
  SettingTabPanelList,
  SettingTabPanelListRow,
  SettingTabPanelListRowTitle,
} from '../common/SettingTabPanelList';
import { NewMultiroleLinkDialogContext } from './NewMultiroleLinkDialog';
import { MultiroleLinkKind } from '../../../../../common/src/ts/types/multiroleLink';

const textInputStyle: React.CSSProperties = {
  width: '100%',
  boxSizing: 'border-box',
  margin: '8px',
};

const MultiroleLinkWebTabPanel: React.SFC = () => {
  return (
    <NewMultiroleLinkDialogContext.Consumer>{(context) => {
      const web = context[MultiroleLinkKind.Web];
      const { url, title, pinColor } = web;

      return (
        <SettingTabPanelList>
          <SettingTabPanelListRow>
            <SettingTabPanelListRowTitle>URL</SettingTabPanelListRowTitle>
            <input
              type="text"
              style={textInputStyle}
              defaultValue={url}
              onChange={(ev) => {
                context.setState({
                  [MultiroleLinkKind.Web]: { ...web, url: ev.target.value },
                });
              }} />
          </SettingTabPanelListRow>
          <SettingTabPanelListRow>
            <SettingTabPanelListRowTitle>タイトル名</SettingTabPanelListRowTitle>
            <input
              type="text"
              style={textInputStyle}
              defaultValue={title}
              onChange={(ev) => {
                context.setState({
                  [MultiroleLinkKind.Web]: { ...web, title: ev.target.value },
                });
              }} />
          </SettingTabPanelListRow>
          <SettingTabPanelListRow>
            <SettingTabPanelListRowTitle>ピンの色</SettingTabPanelListRowTitle>
            <ToolIconRadioButtonSet style={{ width: '320px' }}>
              <ToolIconButton
                text="1"
                active={pinColor === '1'}
                onClick={() => {
                  context.setState({
                    [MultiroleLinkKind.Web]: { ...web, pinColor: '1' },
                  });
                }} />
              <ToolIconButton
                text="2"
                active={pinColor === '2'}
                onClick={() => {
                  context.setState({
                    [MultiroleLinkKind.Web]: { ...web, pinColor: '2' },
                  });
                }} />
              <ToolIconButton
                text="3"
                active={pinColor === '3'}
                onClick={() => {
                  context.setState({
                    [MultiroleLinkKind.Web]: { ...web, pinColor: '3' },
                  });
                }} />
              <ToolIconButton
                text="4"
                active={pinColor === '4'}
                onClick={() => {
                  context.setState({
                    [MultiroleLinkKind.Web]: { ...web, pinColor: '4' },
                  });
                }} />
              <ToolIconButton
                text="5"
                active={pinColor === '5'}
                onClick={() => {
                  context.setState({
                    [MultiroleLinkKind.Web]: { ...web, pinColor: '5' },
                  });
                }} />
              <ToolIconButton
                text="6"
                active={pinColor === '6'}
                onClick={() => {
                  context.setState({
                    [MultiroleLinkKind.Web]: { ...web, pinColor: '6' },
                  });
                }} />
              <ToolIconButton
                text="7"
                active={pinColor === '7'}
                onClick={() => {
                  context.setState({
                    [MultiroleLinkKind.Web]: { ...web, pinColor: '7' },
                  });
                }} />
              <ToolIconButton
                text="8"
                active={pinColor === '8'}
                onClick={() => {
                  context.setState({
                    [MultiroleLinkKind.Web]: { ...web, pinColor: '8' },
                  });
                }} />
              <ToolIconButton
                text="9"
                active={pinColor === '9'}
                onClick={() => {
                  context.setState({
                    [MultiroleLinkKind.Web]: { ...web, pinColor: '9' },
                  });
                }} />
              <ToolIconButton
                text="10"
                active={pinColor === '10'}
                onClick={() => {
                  context.setState({
                    [MultiroleLinkKind.Web]: { ...web, pinColor: '10' },
                  });
                }} />
            </ToolIconRadioButtonSet>
          </SettingTabPanelListRow>
        </SettingTabPanelList>
      );
    }}</NewMultiroleLinkDialogContext.Consumer>
  );
};

export default MultiroleLinkWebTabPanel;
